<script setup>
import { useI18n } from 'vue-i18n';
import SingleHookIntegrationPage from '../shared/SingleHookIntegrationPage.vue';

const { t } = useI18n();
</script>

<template>
  <SingleHookIntegrationPage
    integration-id="openai"
    :header-title="t('INTEGRATION_SETTINGS.OPENAI.HEADER')"
    :empty-title="t('INTEGRATION_SETTINGS.OPENAI.EMPTY_STATE')"
    :empty-description="t('INTEGRATION_SETTINGS.OPENAI.DESCRIPTION')"
    :connect-button-label="t('INTEGRATION_SETTINGS.OPENAI.CONNECT_BUTTON')"
    :disconnect-button-label="t('INTEGRATION_SETTINGS.OPENAI.DISCONNECT_BUTTON')"
    :connected-title="t('INTEGRATION_SETTINGS.OPENAI.CONNECTED')"
    :connected-description="
      t('INTEGRATION_SETTINGS.OPENAI.CONNECTED_DESCRIPTION')
    "
    :disconnect-confirm="t('INTEGRATION_SETTINGS.OPENAI.DISCONNECT.CONFIRM')"
    icon="i-lucide-sparkles"
    icon-class="bg-gradient-to-br from-emerald-500 to-teal-600"
    logo-file="/dashboard/images/integrations/openai.png"
  />
</template>
